import { PixelRatioImage, type PixelRatioImageProps } from "@/components/common/pixel-ratio-image";
import bellImage from "@/assets/agent/bell@3x.webp";

export const BellImage = (props: Omit<PixelRatioImageProps, "images">) => {
  return (
    <PixelRatioImage
      images={[bellImage]}
      {...props}
    />
  );
};

BellImage.displayName = 'BellImage';
